import { Button, Dialog, Portal, Separator, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import { EMAILS_FOR_REVIEW } from "@/constants/routes";
import {
  MANUAL_REVIEW_CASE_RESOLVED_MESSAGE,
  MANUAL_REVIEW_DOCUMENT_MARKED_BROKEN_MESSAGE,
} from "@/constants/manualReview";

export type ManualReviewCompletionVariant = "resolved" | "documentBroken";

interface ManualReviewCaseResolvedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  variant: ManualReviewCompletionVariant;
}

const ManualReviewCaseResolvedDialog = ({
  open,
  onOpenChange,
  variant,
}: ManualReviewCaseResolvedDialogProps) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    onOpenChange(false);
    navigate(EMAILS_FOR_REVIEW, { replace: true });
  };

  const title =
    variant === "documentBroken" ? "Document marked as broken" : "Resolved";
  const bodyText =
    variant === "documentBroken"
      ? MANUAL_REVIEW_DOCUMENT_MARKED_BROKEN_MESSAGE
      : MANUAL_REVIEW_CASE_RESOLVED_MESSAGE;

  return (
    <Dialog.Root
      lazyMount
      open={open}
      closeOnInteractOutside={false}
      closeOnEscape={false}
      onOpenChange={(e: { open: boolean }) => {
        if (e.open) onOpenChange(true);
      }}
      role="alertdialog"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxW={640} w="100%">
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Separator />
            <Dialog.Body py={{ base: 6, md: 10 }} px={8} textAlign="center">
              <Text fontSize={{ base: "lg", md: "xl" }} lineHeight="snug">
                {bodyText}
              </Text>
            </Dialog.Body>
            <Separator />
            <Dialog.Footer py={4} display="flex" justifyContent="flex-end">
              <Button colorPalette="brand" onClick={handleContinue}>
                Continue
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ManualReviewCaseResolvedDialog;
